import { render, staticRenderFns } from "./PersonaSection.vue?vue&type=template&id=06c02eb0"
import script from "./PersonaSection.vue?vue&type=script&lang=js"
export * from "./PersonaSection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports